// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link
      to="/"
      className="logo-link"
      style={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: '#1b1c1d',
        fontWeight: 700,
        fontSize: '1.5rem',
        gap: '0.5rem',
      }}
      aria-label="LOA Platform Home"
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect width="32" height="32" rx="6" fill="#2185D0" />
        <path
          d="M9 10h4v12H9V10zm6 0h4v12h-4V10zm6 4h4v8h-4v-8z"
          fill="white"
        />
      </svg>
      <span>LOA Platform</span>
    </Link>
  );
}
